import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import { CosignNoteMetaBody } from "@/api/(requests)/cosignatureTyped";

import { cosignatureKeys } from "../keyFactory";
import { getCosignatureMeta } from "../queryFunctions/getCosignatureMeta";

type UseCosignatureMetaProps<TData = CosignNoteMetaBody> = {
  enabled?: boolean;
  noteId: string;
  select?: (data: CosignNoteMetaBody) => TData;
};

type CosignatureMetaQueryOptions = UseQueryOptions<
  CosignNoteMetaBody,
  unknown,
  CosignNoteMetaBody,
  ReturnType<typeof cosignatureKeys.meta>
>;

function optionFactory(noteId: string, enabled = true) {
  return {
    enabled,
    queryFn: () => getCosignatureMeta(noteId),
    queryKey: cosignatureKeys.meta(noteId),
  } satisfies CosignatureMetaQueryOptions;
}

export function useCosignatureMeta<TData = CosignNoteMetaBody>({
  enabled,
  noteId,
  select,
}: UseCosignatureMetaProps<TData>) {
  return useQuery({ ...optionFactory(noteId, enabled), select });
}
